// extracted by mini-css-extract-plugin
export var container = "PromoSection-module--container--qD2sG";
export var centeredContainer = "PromoSection-module--centeredContainer--1N49w";